import { Header } from '@/components/layout/Header'
import { Hero } from '@/components/sections/Hero'
import { Features } from '@/components/sections/Features'
import { Stats } from '@/components/sections/Stats'
import { Workflow } from '@/components/sections/Workflow'
import { Pricing } from '@/components/sections/Pricing'
import { Testimonials } from '@/components/sections/Testimonials'
import { CTA } from '@/components/sections/CTA'
import { Footer } from '@/components/layout/Footer'
import { SEO, StructuredData } from '@/components/seo'

export default function LandingPage() {
  return (
    <div className="min-h-screen bg-white">
      <SEO
        title="AI-Powered Hiring Decision Platform"
        description="JumpstoneHR screens candidates in seconds, not days. Our AI-powered platform turns resumes and interviews into clear, evidence-based hiring decisions. Reduce time-to-hire by 80% while improving quality."
        canonical="/"
        structuredData={[
          StructuredData.softwareApplication(),
          StructuredData.webPage(
            'JumpstoneHR - AI-Powered Hiring Decision Platform',
            'AI-powered hiring platform that screens candidates in seconds and helps teams make evidence-based hiring decisions.',
            '/'
          ),
          {
            '@context': 'https://schema.org',
            '@type': 'Product',
            name: 'JumpstoneHR',
            description: 'AI-powered hiring decision platform for modern recruitment teams',
            brand: {
              '@type': 'Brand',
              name: 'JumpstoneHR',
            },
            offers: {
              '@type': 'AggregateOffer',
              lowPrice: '0',
              highPrice: '499',
              priceCurrency: 'CAD',
              offerCount: '4',
            },
            aggregateRating: {
              '@type': 'AggregateRating',
              ratingValue: '4.8',
              reviewCount: '127',
              bestRating: '5',
              worstRating: '1',
            },
          },
        ]}
      />
      <Header />
      <main>
        <Hero />
        <Features />
        <Stats />
        <Workflow />
        <Pricing />
        <Testimonials />
        <CTA />
      </main>
      <Footer />
    </div>
  )
}
